import { getLocale } from "../runtime";

const da_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Siden blev ikke fundet`
};

const en_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Page not found`
};

const es_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Página no encontrada`
};

const fi_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sivua ei löytynyt`
};

const nb_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Siden ble ikke funnet`
};

const sv_pagenotfound = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Sidan hittades inte`
};

const pagenotfound = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_pagenotfound(inputs)
	if (locale === "en") return en_pagenotfound(inputs)
	if (locale === "es") return es_pagenotfound(inputs)
	if (locale === "fi") return fi_pagenotfound(inputs)
	if (locale === "nb") return nb_pagenotfound(inputs)
	if (locale === "sv") return sv_pagenotfound(inputs)
	return "pageNotFound";
};

export { pagenotfound as "pageNotFound" };